import { StatisticsOrderQuery } from '@dreryk/egabinet-statistics-frontend-api';

import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { refetchCqrsQuery } from '@dreryk/command-query-react-common';

import { statisticsTranslationKeys } from '../../translations';

export const handleStatisticsRefetch = (closeModal: VoidFunction): void => {
   refetchCqrsQuery(StatisticsOrderQuery).then(() => {
      dispatchSnackbarPositiveEvent(statisticsTranslationKeys.generatedSuccessfully);
      closeModal();
   });
};
